import React, { memo } from 'react'
import PropTypes from 'prop-types'

import { util } from '../../../util'

/**
 * @returns {*} Error message component
 */
const ErrorMessage = ({ messages, className, type }) => {
    const iconType = {}
    if (type === 'info') {
        iconType.renderIcon = util.InfoOutlinedIcon
    } else if (type === 'danger') {
        iconType.color = 'danger'
        iconType.renderIcon = util.ReportProblemOutlinedIcon
    }

    return (
        <div className={util.joinClasses('error-message', className, type)}>
            <div className={'error-message__text px-2'}>
                {messages.map((msg, i) => (
                    <p key={i} className={util.joinClasses(iconType.color, type, 'mb-1')}>
                        {msg}
                    </p>
                ))}
            </div>
        </div>
    )
}

ErrorMessage.propTypes = {
    /** @param messages {String} Error message text */
    messages: PropTypes.array,

    /** @param className {String} class name which will overrides or adds extra styling for default class name */
    className: PropTypes.string,

    /** @param type {String} type of error message {info, warning} */
    type: PropTypes.oneOf(['info', 'danger']),
}

export default memo(ErrorMessage)
